export const API_URL = "API_URL";
export const HUB_URL = "HUB_URL";
export const HUB_WORKER_URL = "HUB_WORKER_URL";
export const IDENTITY_URL = "IDENTITY_URL";
